export const buildVersion = 'feature/KDATA-3404-add-move-address-fields-to-weights';
